/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Settings_DescriptionInputs */

const en_welcome_settings_description = /** @type {(inputs: Welcome_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These settings can be changed any time from inside the app. They are stored locally in your browser.`)
};

const fr_welcome_settings_description = /** @type {(inputs: Welcome_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces réglages peuvent être modifiés à tout moment depuis l'application. Ils sont sauvegardés localement dans votre navigateur.`)
};

const ms_sg2_welcome_settings_description = /** @type {(inputs: Welcome_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapan ini boleh diubah pada bila-bila masa dari dalam aplikasi. Ia disimpan secara tempatan dalam pelayar anda.`)
};

/**
* | output |
* | --- |
* | "These settings can be changed any time from inside the app. They are stored locally in your browser." |
*
* @param {Welcome_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_settings_description = /** @type {((inputs?: Welcome_Settings_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Settings_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_settings_description(inputs)
	if (locale === "fr") return fr_welcome_settings_description(inputs)
	return ms_sg2_welcome_settings_description(inputs)
});